<template>
  <div class="page-box">
    <!--    头部-->
    <headerBar />
    <siteNav :selectedIndex="selectedIndex" />
    <!--    头部end-->

    <!---->
    <div class="center-box">
      <div class="qualityControl-box">
        <div class="crumbs">首页 > 质控网络</div>
        <div class="title-nav">
          <div class="nav-li" v-for="(item, index) in navItems" :key="index" :class="{ active: activeIndex === item.value }" @click="setActive(item.value)">
            {{ item.name }}
          </div>
        </div>
        <network v-if="networkList.length > 0" :network="networkList" :activeIndex="activeIndex" :page="page" @sizeChange="sizeChange" @currentChange="currentChange" />
        <empty class="empty-margin" v-if="networkList.length <= 0"></empty>
      </div>
    </div>
    <!---->

    <footer-bar></footer-bar>
    <!--    页脚end-->
    <!---->
  </div>
</template>

<script>
import FooterBar from "../../components/base/footerBar";
import headerBar from "@/components/base/headerBar";
import siteNav from "@/components/base/siteNav";
import network from "@/components/network/index.vue";
import { getQualityControl } from '@/api/home'
import empty from "@/components/empty/index";

export default {
  name: "index",
  components: { FooterBar, headerBar, siteNav, network, empty },
  data() {
    return {
      selectedIndex: 5,
      navItems: [{
        name: '省级质控中心',
        value: 'PROVINCE'
      }, {
        name: '地市级质控中心',
        value: 'CITY'
      }],
      networkList: [],
      activeIndex: "PROVINCE",
      page: {
        number: 1,
        limit: 12,
        total: 0,
      },
      searchTitle: '',
    }
  },
  watch: {
    "$route" (to, from) {
      this.searchTitle = to.query.title ? to.query.title : ''
      this.page.number = 1
      this.getQualityControl()
    },
  },
  methods: {
    setActive(index) {
      this.activeIndex = index; // 设置当前激活的项
      this.networkList = []
      this.getQualityControl()
    },
    // 分页查询分级质控
    getQualityControl() {
      getQualityControl({
        number: this.page.number,
        limit: this.page.limit,
        level: this.activeIndex,
        centerName: this.searchTitle,
      }).then(res => {
        this.networkList = res.data
        this.page.total = res.totalCount
      })
    },
    sizeChange(value) {
      this.page.number = 1
      this.page.limit = value
      this.getQualityControl()
    },
    currentChange(value) {
      this.page.number = value
      this.getQualityControl()
    },
  },
  mounted() {
    if (this.$route.query.title) {
      this.searchTitle = this.$route.query.title
    }
    this.getQualityControl()
  }
}
</script>

<style lang="less" scoped>
.center-box {
  padding-bottom: 80px;
}

/deep/.el-input__inner {
  // height: 32px;
  // border: 1px solid var(---, rgba(0, 0, 0, 0.15)) !important;
  // color: rgba(0, 0, 0, 0.45) !important;
  // line-height: 30px;
}

/deep/.el-pagination button {
  border: 1px solid var(---, rgba(0, 0, 0, 0.15)) !important;
  background: #fff !important;
  width: 32px;
  height: 32px;
  color: rgba(0, 0, 0, 0.45) !important;
  line-height: 30px;
}

/deep/.el-pager li {
  border: 1px solid var(---, rgba(0, 0, 0, 0.15)) !important;
  background: #fff !important;
  width: 32px;
  height: 32px;
  border-right: 2px;
  color: rgba(0, 0, 0, 0.45) !important;
  line-height: 30px;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background: #BD181E !important;
  color: rgba(255, 255, 255, 0.65) !important;
}
</style>



// WEBPACK FOOTER //
// src/views/Network/index.vue